import { render, staticRenderFns } from "./MyNotifyDialog.vue?vue&type=template&id=9577958e&scoped=true&"
import script from "./MyNotifyDialog.vue?vue&type=script&lang=js&"
export * from "./MyNotifyDialog.vue?vue&type=script&lang=js&"
import style0 from "./MyNotifyDialog.vue?vue&type=style&index=0&id=9577958e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9577958e",
  null
  
)

export default component.exports